import React, { useState } from 'react';
import { theme, styles } from '../constants.js';

const FormInput = ({ label, type = "text", value, onChange, placeholder, required }) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div style={styles.inputGroup}>
      <label style={styles.label}>{label} {required && <span style={{color: theme.danger}}>*</span>}</label>
      {type === "textarea" ? (
        <textarea style={{...styles.input, ...styles.textarea, ...(isFocused ? styles.inputFocus : {})}} value={value} onChange={onChange} placeholder={placeholder} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} />
      ) : (
        <input type={type} style={{...styles.input, ...(isFocused ? styles.inputFocus : {})}} value={value} onChange={onChange} placeholder={placeholder} required={required} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} />
      )}
    </div>
  );
};

export default FormInput;
